import PropTypes from 'prop-types';
import React from 'react';

import TableRow from './TableRow';

export default function Table(props) {
  if (!props.row || !props.row.length) {
    return false;
  }

  return <table><tbody>{props.row.map((row, index) => <TableRow key={index} {...row}/>)}</tbody></table>;
}

Table.propTypes = {
  row: PropTypes.array
};


// WEBPACK FOOTER //
// ./modules/Common/components/Table.js